"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessNetwork = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Size_1 = require("../render/Size");
var BusinessNetwork = (function (_super) {
    __extends(BusinessNetwork, _super);
    function BusinessNetwork() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.BUSINESS_NETWORK,
            tags: [Tags_1.Tags.EARTH],
            cost: 4,
            metadata: {
                cardNumber: '110',
                description: 'Decrease your M€ production 1 step.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action(undefined, function (eb) { return eb.empty().startAction.empty(); }).text('Action: Look at the top card and either buy it or discard it', Size_1.Size.SMALL, true).br;
                    b.production(function (pb) { return pb.megacredits(-1); });
                }),
            },
        }) || this;
    }
    BusinessNetwork.prototype.canPlay = function (player) {
        return player.getProduction(Resources_1.Resources.MEGACREDITS) >= -4;
    };
    BusinessNetwork.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, -1);
        return undefined;
    };
    BusinessNetwork.prototype.canAct = function () {
        return true;
    };
    BusinessNetwork.prototype.action = function (player) {
        return player.drawCardKeepSome(1, { paying: true });
    };
    return BusinessNetwork;
}(Card_1.Card));
exports.BusinessNetwork = BusinessNetwork;
